import { Container, Row, Col } from "react-bootstrap";
import { Button } from 'sfy-react'



function ButtonContainer(props) {
 const { isDisabled, BtnOneText, BtnTwoText, onBtnOneClick, onBtnTwoClick,BtnOneClass,BtnTwoClass} = props;
 return (
  <Container fluid className="m-0 g-0 p-20" style={{ backgroundColor: '#FFFFFF', height: "100%" }}>
   <Row className="flex-column-reverse flex-md-row">
  
    <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
     <Button type='button' text={BtnTwoText} classes={BtnTwoClass}
      handleOnClick={onBtnTwoClick} >
     </Button>
    </Col>
    <Col xs={12} md={6} >
     <Button isDisabled={isDisabled} type='button' text={BtnOneText} classes={BtnOneClass}
      handleOnClick={onBtnOneClick} >
     </Button>
    </Col>
   </Row>
  </Container>
 );
}
export default ButtonContainer;
